export const INVALID = 'invalid'
export const DEFINED = 'defined'
export const UNDEFINED = 'undefined'
export const BLANK = 'blank'
export const EMPTY = 'empty'
export const EQUAL = 'equal'
export const NOT_EQUAL = 'not_equal'
export const WRONG_TYPE = 'wrong_type'
export const WRONG_CONSTRUCTOR = 'wrong_constructor'

/**
 * Synchronized with backend
 **/

export const OBJECT_MISSING_PROPERTIES = 'object_missing_properties'

/* related to activation codes */

export const REGISTRATIONS_LIMIT_REACHED = 'registrations_limit_reached'
